import type { RefObject } from 'react';

// ────────────────────────────────────────────────────────────────────────────────

export const AwsWafWebView = (_props: AwsWebViewProps) => {
  return null;
};

// ─── Types ──────────────────────────────────────────────────────────────────────

type AwsWebViewProps = {
  generateAwsWafTokenRef: RefObject<() => Promise<string>>;
};
